// Angular imports
import { Component, OnInit, OnDestroy, Input, ChangeDetectionStrategy } from '@angular/core';

// Import rxjs
import { Subject } from 'rxjs';

// Import column types
import { ColumnMap } from '../../types';
import { ViewModelLine } from 'src/app/state-management/calculation-state';

@Component({
    selector: 'sub-category-total-row',
    templateUrl: './sub-category-total-row.component.html',
    styleUrls: ['./sub-category-total-row.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SubCategoryTotalRowComponent implements OnInit, OnDestroy {
    public description = '';

    @Input()
    public set subcategory(value: ViewModelLine) {
        this.setValues(value);
        this.description = value.description;
    };

    @Input() public columns: ColumnMap;

    // Fields for totals
    public _hoursNormTotal: number;
    public _hoursNetTotal: number;
    public _wagesNetTotal: number;
    public _hoursGrossTotal: number;

    public _equipmentNormTotal: number;
    public _equipmentNetTotal: number;
    public _equipmentGrossTotal: number;

    public _materialNormTotal: number;
    public _materialNetTotal: number;
    public _materialGrossTotal: number;

    public _subcontractingNormTotal: number;
    public _subcontractingNetTotal: number;
    public _subcontractingGrossTotal: number;

    public _normTotal: number;
    public _grossNormTotal: number;
    public _netTotal: number;
    public _grossTotal: number;

    constructor() { }

    public ngOnInit() {
    }

    public ngOnDestroy() {
    }

    /**
     * Refreshes the internal state of the total row. (Totals)
     * @returns void
     */
    public setValues(subcategory: ViewModelLine): void {
        // Destructure
        const {
            aggregation: {
                equipment: {
                    gross: equipmentTotalGross,
                    net: equipmentTotalNet,
                    norm: equipmentTotalNorm
                },
                hours: {
                    gross: hoursTotalGross,
                    net: hoursTotalNet,
                    norm: hoursTotalNorm,
                    hours: totalHours
                },
                material: {
                    gross: materialTotalGross,
                    net: materialTotalNet,
                    norm: materialTotalNorm
                },
                subcontracting: {
                    gross: subcontractingTotalGross,
                    net: subcontractingTotalNet,
                    norm: subcontractingTotalNorm
                },
                all: {
                    gross: allTotalGross,
                    net: allTotalNet,
                    norm: allTotalNorm,
                    unitPrice: totalUnitPrice
                }
            }
        } = subcategory;

        this._hoursNormTotal = hoursTotalNorm;
        this._hoursNetTotal = totalHours;
        this._wagesNetTotal = hoursTotalNet;
        this._hoursGrossTotal = hoursTotalGross;

        this._equipmentNormTotal = equipmentTotalNorm;
        this._equipmentNetTotal = equipmentTotalNet;
        this._equipmentGrossTotal = equipmentTotalGross;

        this._materialNormTotal = materialTotalNorm;
        this._materialNetTotal = materialTotalNet;
        this._materialGrossTotal = materialTotalGross;

        this._subcontractingNormTotal = subcontractingTotalNorm;
        this._subcontractingNetTotal = subcontractingTotalNet;
        this._subcontractingGrossTotal = subcontractingTotalGross;

        // this._normTotal = allTotalNorm;
        this._grossNormTotal = totalUnitPrice;
        this._netTotal = allTotalNet;
        this._grossTotal = allTotalGross;
    }
}
